import { connect } from 'react-redux';
import View from './AccountsOverviewView';
import {
  currentClientId,
  hasAddAnotherGoalSelector,
  canGoBackSelector,
  isBusySelector,
} from '../../AdvWorkflow/AdvWorkflowSelector';
import {
  accountsOverviewSelector,
  noDeletedAccountsSelector,
  isEmptyStateSelector,
} from './AccountsOverviewSelector';
import { accountsSelector } from './AccountsManualStepSelector';
import { EDIT_ACCOUNT, DELETE_ACCOUNT } from './AccountsOverviewMenuOptions';
import deleteAccount from './AccountsOverviewActions';
import { setViewId, setDraftAccount } from './AccountsManualStepActions';
import { EDIT, ADD, PLAID } from './AccountsManualStepViews';
import { bumpProgressBar, jump } from '../../AdvWorkflow/AdvWorkflowActions';
import {
  isConsumerArea,
  hasAccessToLinkAccountsSelector,
  hasPlaidSelector,
} from '../../../CommonSelectors/CommonAreaSelector';

const mapStateToProps = (state, ownProps) => ({
  clientId: currentClientId(state, ownProps),
  accountsList: accountsOverviewSelector(state, ownProps),
  graphAccounts: accountsSelector(state, ownProps),
  isEmptyState: isEmptyStateSelector(state, ownProps),
  noDeletedAccounts: noDeletedAccountsSelector(state, ownProps),
  hasAddAnotherGoal: isConsumerArea(state) && hasAddAnotherGoalSelector(state),
  canGoBack: canGoBackSelector(state, ownProps),
  hasAccessToLinkAccounts: hasAccessToLinkAccountsSelector(state),
  isLoading: isBusySelector(state, ownProps),
  hasPlaid: hasPlaidSelector(state),
});

const mapDispatchToProps = dispatch => ({
  goToAddAnotherGoal: clientId => () => {
    window.ADV.util.Router.go2('ClientEditPlan', {
      clientId,
    });
  },
  onMenuOptionClicked: (workflowId, clientId, id, graphAccounts) => menuOption => () => {
    switch (menuOption) {
      case EDIT_ACCOUNT:
        dispatch(
          setDraftAccount(
            graphAccounts.find(
              ({ AccountId, frontEndId }) => AccountId === id || frontEndId === id,
            ),
            workflowId,
            clientId,
          ),
        );
        dispatch(bumpProgressBar(workflowId));
        dispatch(setViewId(EDIT, workflowId, clientId));
        break;
      case DELETE_ACCOUNT:
        dispatch(deleteAccount(graphAccounts, id, workflowId, clientId));
        break;
      default:
    }
  },
  takeMeToMyAccounts: workflowId => () => {
    dispatch(jump(1, workflowId));
  },
  filterDeletedAccounts: graphObject => ({
    Accounts: graphObject.Accounts.filter(({ IsDeleted }) => IsDeleted),
  }),
  onAddAccount: (workflowId, clientId, hasAccessToLinkAccounts, hasPlaid) => () => {
    dispatch(bumpProgressBar(workflowId));

    if (hasAccessToLinkAccounts) {
      dispatch(setViewId(hasPlaid ? PLAID : ADD, workflowId));
    } else {
      dispatch(setViewId(ADD, workflowId));
    }
  },
});

const AccountsOverviewContainer = connect(mapStateToProps, mapDispatchToProps)(View);

export default AccountsOverviewContainer;
